import React, {
  useState,
  useMemo,
  useCallback,
  useEffect,
} from 'react';
import PropTypes from 'prop-types';
import { useField } from 'formik';
import classNames from 'classnames';
import debounce from 'lodash/debounce';

import Error from '@components/form/error';
import { useIsMount } from '@hooks/useIsMount';

export default function Text({ label, withDelay, ...props }) {
  const isMount = useIsMount();
  const [field, meta, helpers] = useField(props);
  const [value, setValue] = useState(field.value);
  const delay = useCallback(debounce(helpers.setValue, 1000), [helpers]);

  const classes = useMemo(() => (
    classNames(
      'input__wrapper',
      { error: meta.touched && !!meta.error },
    )
  ), [field, meta]);

  useEffect(() => {
    if (!isMount) {
      if (withDelay) {
        delay(value);
      } else {
        helpers.setValue(value);
      }
    }
  }, [value]);

  useEffect(() => {
    setValue(field.value);
  }, [field.value]);

  return (
    <div className={classes}>
      <label>
        <span className='input__wrapper__label'>{label}</span>
        <div className='input__wrapper__input'>
          <input
            {...field}
            type='text'
            {...props}
            value={value}
            onChange={({ target }) => setValue(target.value)}
          />
        </div>
      </label>
      <Error name={field.name} />
    </div>
  );
}

Text.defaultProps = {
  label: '',
  withDelay: false,
};

Text.propTypes = {
  label: PropTypes.string,
  withDelay: PropTypes.bool,
};
